module.exports = __webpack_public_path__ + "static/scale-model-of-deepwood-museum-&-gardens-in-salem-oregon-b1d41a1b9b84c4cdf9e2ab0094f5b93e.png";